import type { GameAction, Screen } from "./types";

/**
 * Ekran geçiş kuralları — tüm menü akışı tek yerde, test edilebilir saf fonksiyonlar.
 * Dönüş `null` ise ekranda kalınır.
 */

/** Başlık ekranı: her eylem ayarlara götürür. */
export function transitionFromTitle(action: GameAction): Screen | null {
  if (action === "ok" || action === "up" || action === "down") return "settings";
  return null;
}

/** Duraklatma ekranı. */
export function transitionFromPause(action: GameAction): Screen | null {
  if (action === "ok" || action === "pause") return "game";
  if (action === "back") return "title";
  return null;
}

/** Oyun sonu ekranı. */
export function transitionFromGameOver(action: GameAction): Screen | null {
  if (action === "ok") return "game"; // aynı ayarlarla tekrar
  if (action === "back") return "title";
  return null;
}
